/* eslint import/prefer-default-export: 0 */

export const drugTypes = [
  'Cocaine',
  'Stimulants',
  'THC',
  'Depressants',
  'Ketamine',
  'Narcotics',
  'Hallucinogenic',
  'Steroids',
  'Inhalants',
  'Other',
];

//PVQ Dropdown values
export const substanceDrugOptions = [
  'Cocaine or crack cocaine (such as rock or freebase)',
  'Stimulants (such as amphetamines, speed, crystal meth, or ecstasy)',
  'Depressants (such as barbiturates, methaqualone, or tranquilizers)',
  'Ketamine (such as special K or jet)',
  'Narcotics (such as opium, morphine, codeine, or heroin)',
  'Hallucinogenic (such as LSD, PCP, or mushrooms)',
  'Steroids (such as the clear or juice)',
  'Inhalants (such as toluene or amyl nitrate)',
  'Other',
];

//PVQ Dropdown values
export const counselingOrderedByOptions = [
  'Employer',
  'Military Commander',
  'Medical Professional',
  'Mental Health Professional',
  'Court Official/Judge',
  'Other',
];

//PVQ Dropdown values
export const counselingRecommendedByOptions = [
  'Employer',
  'Military Commander',
  'Employee Assistance Program',
  'Medical Professional',
  'Mental Health Professional',
  'Other',
  'No',
];

//PVQ Dropdown values
export const criminalJusticeorPublicSafetyPosition = [
  'Police/law enforcement officer',
  'Parole/probation officer',
  '911 dispatcher',
  'Correction officer',
  'Lawyer',
  'Court official',
  'Firefighter',
  'EMS',
  'Medical and health services member',
  'Emergency response team member',
  'Other'
];
